import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/styles/index.css'
import store from './store'
import router from './router/index'
import App from './App.vue'
//import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
//import '@/styles/quick-website.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
const app = createApp(App)

app.use(ElementPlus)
app.use(router)
app.use(store)
app.mount('#app')

router.afterEach((to) => {
  // 设置每次路由变化后的页面标题
  document.title = to.meta.title || '默认标题';
})